module.exports = __webpack_public_path__ + "img/free_multiplier_2.a24bca71.png";